import { Component, Input, OnInit } from '@angular/core';
import {
  WagtailHtmlRendererInterface,
  WagtailPageContentElementInterface,
  WagtailPageContentRendererInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-html',
    templateUrl: './html.component.html',
    styleUrls: ['./html.component.scss'],
    standalone: false
})
export class WagtailHtmlComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailPageContentRendererInterface>
  content?: WagtailHtmlRendererInterface

  ngOnInit(): void {
    if (this.definition) {
      this.content = (this.definition.value as WagtailHtmlRendererInterface)
    }
  }
}
